<app-reports
  title="WAG Billing API Reports"
  [filtersForm]="filtersForm"
  [reportsUrl]="reportsUrl">

  <ng-template appNewReportOptionsTemplate let-filtersForm="filtersForm">
    <ng-container [formGroup]="filtersForm">

      <app-report-month-range-option
        label="Billing Date"
        name="billingDate"
        formControlName="billingDate"
        [required]="true"
        [minYear]="billingDateFilterOptions.minYear"
        [minMonth]="billingDateFilterOptions.minMonth"
        [maxYear]="billingDateFilterOptions.maxYear"
        [maxMonth]="billingDateFilterOptions.maxMonth"
      />

    </ng-container>
  </ng-template>

  <ng-template appReportDetailsTemplate let-report="report">

    <app-report-applied-month-range-option
      [options]="report.filters"
      name="billingDate"
      label="Billing Date" />

  </ng-template>

</app-reports>
